import { render } from "./ResultsPhasesComponent.vue?vue&type=template&id=172e707a"
import script from "./ResultsPhasesComponent.vue?vue&type=script&lang=js"
export * from "./ResultsPhasesComponent.vue?vue&type=script&lang=js"
script.render = render

export default script